import React from 'react';
import RelationshipCompanyContactsTable from '@/components/tables/RelationshipCompanyContactsTable';

export const RelationshipCompanyContactsTab = () => <RelationshipCompanyContactsTable />;

RelationshipCompanyContactsTab.displayName = 'RelationshipCompanyContactsTab';

export default RelationshipCompanyContactsTab;
